<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/FatjLg/tc-custom/9781446360200.jpg?1697287584975" alt="This image is the cover for the book 9 Classic Quilt Blocks, Quilt Essentials"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">9 Classic Quilt Blocks, Quilt Essentials
      </h1>
      <p class="bookDescription body article font2">
        <b>Basic building blocks for crafting the perfect quilt from the award-winning expert and author of <i>The Essential Sampler Quilt Book</i>.</b><br/>  <br/> A collection of classic sampler quilt block patterns from quilting expert Lynne Edwards. Features step-by-step instructions for creating nine classic quilting blocks which can be quilted as you go. Includes techniques for finishing, quilting, and how to turn blocks into a sampler quilt or wall hanging. Choose from classic quilt blocks including Rail Fence, Honey Bee, Trip Around the World, Log Cabin, Dresden Plate, Quick Triangles, Spider’s Web, Tumbling Blocks, and Maple Leaf. A great introduction to the world of quilt block piecing.<br/>  <br/> In recognition of her contribution to arts and crafts, Lynne was awarded an MBE, a Member of the Order of the British Empire.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lynne Edwards
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      David & Charles
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?310a16d4